export const getVersionInfo = () => ({
	LATEST_TAG: process.env.REACT_APP_LATEST_TAG,
	LATEST_COMMIT: process.env.REACT_APP_LATEST_COMMIT,
	NODE_ENV: process.env.NODE_ENV,
});
